import { TagElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class Tag extends TagElement {}
export default Tag;